export default "__VITE_ASSET__48a2866c__"